module.exports = __webpack_public_path__ + "7883a88e1a303a5fd1ddd74e969eb275.pdf";